export default __webpack_public_path__ + "static/shimianmaifu-f4a57770626f8523a9131b60c24bea26.png";